import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface WorkplacesServiceInterface {
  codEmpresa?: number;
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  reqBody?: ReqBodyType;
  workplaceId?: number;
}

class WorkplacesService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listWorkplaces = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SisMob_CadCliEndLT?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}&tipoAcao=6&tipoEnd=4&codEnd=0`,
    });
  };

  getWorkplace = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    workplaceId,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SisMob_CadCliEndLT?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}&tipoAcao=7&tipoEnd=4&codEnd=${workplaceId}`,
    });
  };

  createWorkplace = async ({
    reqBody,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SisMob_CadCliEndLT',
      reqBody: JSON.stringify({ ...JSON.parse(reqBody as string) as object, tipoAcao: 1 }),
    });
  };

  updateWorkplace = async ({
    reqBody,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SisMob_CadCliEndLT',
      reqBody: JSON.stringify({ ...JSON.parse(reqBody as string) as object, tipoAcao: 2 }),
    });
  };

  updateWorkplaceStatus = async ({
    reqBody,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SisMob_CadCliEndLT',
      reqBody: JSON.stringify({ ...JSON.parse(reqBody as string) as object, tipoAcao: 3 }),
    });
  };

  createManyWorkplaces = async ({
    reqBody,
    token,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SisMob_CadCliEndLT',
      reqBody,
    });
  };

  getAffreightmentOperators = async({
    token,
    codEmpresa,
    codUsu,
    perfilUsu,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SisMob_CadCliLista?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilUsu=${perfilUsu}&codLista=1`,
    });
  };

  checkIfWorkplaceCodeAlreadyExists = async({
    token,
    reqBody,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SisMob_CadCliEndLT_ValidarCod',
      reqBody
    });
  };

  changeLinesAndOperatorsExceptions = async({
    token,
    reqBody,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_ListaExcecaoRot',
      reqBody
    });
  };

  changeLinesAndOperatorsBias = async({
    token,
    reqBody,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_BiasRot',
      reqBody
    });
  };

  getOperatorsAndLinesOptions = async({
    token,
    codUsu,
    perfilUsu,
    codEmpresa,
  }: WorkplacesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ListasGerais?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoAcao=20`,
    });
  };
}

export default new WorkplacesService();
